import {
	saveAuthToCookie,
	saveUserToCookie,
	saveUserBalanceToCookie,
	saveUserCommissionRateToCookie,
	saveUserDeliveryChargeToCookie,
} from '@/utils/cookies.js';

// 로그인 action => mutations에 전달

export default {
	// 로그인
	async LOGIN({ commit }, payload) {
		const response = await this.$authApi.loginUser(payload);

		// console.log(response.data.username);
		commit('SET_USER', response.data.username);
		commit('SET_USERNAME', response.data.username);
		commit('SET_TOKEN', response.data.token);
		saveUserToCookie(response.data.username);
		saveAuthToCookie(response.data.token);

		return response;
	},

	// 회원가입
	async SIGNUP({ commit }, payload) {
		const response = await this.$authApi.signupCustomerUser(payload);
		return response;
	},

	// 회원정보 가져오기
	async getCustomerShop({ commit }, param) {
		try {
			const { data } = await this.$authApi.fetchCustomerShop(param);
			commit('SET_CUSTOMERSHOP_DATA', data);
			console.log(data);
			// 수수료율, 택배비(쿠키, store에 저장)
			commit('SET_COMMISSIONRATE', data.buyingCommissionRate);
			commit('SET_DELIVERYCHARGE', data.outDeliveryCharge);
			commit('SET_BALANCEAMOUNT', data.balanceAmountSum);
			saveUserCommissionRateToCookie(data.buyingCommissionRate);
			saveUserDeliveryChargeToCookie(data.outDeliveryCharge);
			saveUserBalanceToCookie(data.balanceAmountSum);
		} catch (error) {}
	},
	// 회원정보 수정
	async updateCustomerShop({ commit }, param) {
		const response = await this.$authApi.updateCustomerShopByBody(param);
		return response;
	},
	// 비밀번호 변경
	async updatePassword({ commit }, param) {
		const response = await this.$authApi.updatePasswordByBody(param);
		return response;
	},
	// 파일 업로드 후 db 저장
	async registerCustomerFile({ commit }, param) {
		try {
			await this.$authApi.registerCustomerFileByBody(param);
		} catch (error) {}
	},
	// 기존 파일 제거
	async deleteCustomerFile({ commit }, param) {
		console.log(param);
		try {
			await this.$authApi.deleteCustomerFilePost(param);
		} catch (error) {}
	},

	// async REFRESH_TOKEN({ commit }, data) {
	// 	const response = await refreshToken(data);

	// 	// console.log(response)
	// 	commit('SET_USER', response.data.username);
	// 	commit('SET_TOKEN', 'Bearer ' + response.data.token);
	// 	saveUserToCookie(response.data.username);
	// 	saveAuthToCookie('Bearer ' + response.data.token);

	// 	return response;
	// },
};
